var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"app":""}},[_c('v-main',{staticClass:"az-main-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }